import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/auth/useAuth";
import { useDataAccessProblem } from "@/shared/lib/data-client";

/**
 * A message above the page when data.mdf.lu refused the map files (no valid
 * data cookie). Nothing is shown while the files load fine.
 */
export default function DataAccessNotice() {
  const problem = useDataAccessProblem();
  const { login } = useAuth();
  const location = useLocation();
  if (!problem) return null;

  const message = {
    "signed-out": "Your session has ended. Please sign in again to load the map data.",
    "no-access": "Your account has no access to the map data. Ask your MDF administrator if you need it.",
    unavailable: "Map data is temporarily unavailable. Please try again in a few minutes.",
  }[problem];

  return (
    <div
      role="alert"
      className="pointer-events-none fixed inset-x-4 top-16 z-50 flex justify-center md:top-4"
    >
      <div className="pointer-events-auto flex max-w-lg flex-wrap items-center gap-3 rounded-xl border border-border bg-background px-4 py-3 text-sm text-foreground shadow-lg">
        <p className="min-w-0 flex-1">{message}</p>
        {problem === "signed-out" && (
          <Button
            size="sm"
            onClick={() => void login({ returnTo: location.pathname + location.search })}
          >
            Sign in
          </Button>
        )}
        {problem === "unavailable" && (
          <Button size="sm" variant="outline" onClick={() => window.location.reload()}>
            Try again
          </Button>
        )}
      </div>
    </div>
  );
}
